const customFonts = {
  regularFont: "DFDS, sans-serif !important",
  boldFont: "DFDS-Bold, sans-serif !important",
  italicFont: "DFDS-Italic, sans-serif !important",
  lightFont: "DFDS-Light, sans-serif !important",
};

export default customFonts;
